export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10855.8d73bec5.jpg";